import * as React from "react";

function CubeSvg(props) {
  return (
    <svg
      width={68}
      height={68}
      viewBox="0 0 68 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width={68} height={68} rx={34} fill="#F2FFF3" />
      <path
        d="M16.34 24.88L34 35.1l17.54-10.16"
        stroke="url(#paint0_linear_1071_17722)"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34 53.22V35.08"
        stroke="url(#paint1_linear_1071_17722)"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.86 14.96L19.18 20.9c-2.42 1.34-4.4 4.7-4.4 7.46v11.3c0 2.76 1.98 6.12 4.4 7.46l10.68 5.94c2.28 1.26 6.02 1.26 8.3 0l10.68-5.94c2.42-1.34 4.4-4.7 4.4-7.46v-11.3c0-2.76-1.98-6.12-4.4-7.46l-10.68-5.94c-2.3-1.28-6.02-1.28-8.3 0z"
        stroke="url(#paint2_linear_1071_17722)"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44 36.48v-7.32L25.02 18.2"
        stroke="url(#paint3_linear_1071_17722)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1071_17722"
          x1={33.9398}
          y1={24.8799}
          x2={33.9398}
          y2={35.0999}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#099D16" />
          <stop offset={1} stopColor="#006209" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1071_17722"
          x1={34.5}
          y1={35.0801}
          x2={34.5}
          y2={53.2201}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#099D16" />
          <stop offset={1} stopColor="#006209" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1071_17722"
          x1={34.0103}
          y1={14}
          x2={34.0103}
          y2={54.0051}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#099D16" />
          <stop offset={1} stopColor="#006209" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1071_17722"
          x1={34.5095}
          y1={18.2002}
          x2={34.5095}
          y2={36.4802}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#099D16" />
          <stop offset={1} stopColor="#006209" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default CubeSvg;
